(function () {
    "use strict";

    var UtcTimestampParameterControl = Solovis.defineClass(
        "Solovis.Reports.Parameters.UtcTimestampParameterControl",
        Solovis.UI.BaseControl,
        function (options) {
            this.initialParameterValue = (typeof options.initialValue != "undefined") ? options.initialValue : null;

            this._utcDisplayMode = "utc";
            if (options.settings && Solovis.isNotNull(options.settings.utcDisplayMode)) {
                this._utcDisplayMode = options.settings.utcDisplayMode;
            }
        });


    UtcTimestampParameterControl.prototype.doInit = function () {
    };

    UtcTimestampParameterControl.hasNewRender = true;

    UtcTimestampParameterControl.prototype.doRender = function () {
        const enabled = (this.options as Solovis.UI.BaseControlOptions).renderMode === 'modern';
        if (enabled) {
            return this.doRenderNew();
        } else {
            this.doRenderClassic();
        }
    };

    UtcTimestampParameterControl.prototype.doRenderNew = function () {
        const self = this;

        //this.initialParameterValue = newValue;
        const currentDate = self._convertUtcTimestampToDate(self.initialParameterValue)
        Solovis.UX.Utils.placeComponent(
            'DateTimePicker',
            this.container[0],
            {
                defaultValue: currentDate,
                // NOTE: the bounds below come from InvData.Util.DateIndexHelper::getDateFromDateIndexUsingSlowMethod
                // should prevent an invalid date index.
                minDate: new Date(1900, 0, 1),
                maxDate: new Date(2149, 11, 31),
                onChange: (date: Date) => {
                    try {
                        const dateIndex = self._convertDateToUtcTimestamp(date);
                        self.initialParameterValue = dateIndex;
                        self.notifyParameterValueChanged();
                    } catch (error) {
                        // TODO: actual error handling for these controls.
                    }
                }
            }
        )
    };
    //NOTE: grabbed from inputControl:652
    UtcTimestampParameterControl.prototype._convertDateToUtcTimestamp = function (dateValue: Date) {
        if (dateValue) {
            if (this._utcDisplayMode == "local") {
                return dateValue.getTime();
            }
            else {
                return Solovis.Time.getLocalDateFromUtcDate(dateValue).getTime();
            }
        }

        return null;
    }

    UtcTimestampParameterControl.prototype._convertUtcTimestampToDate = function (value: number | null | Date) {
        if (Solovis.isNull(value)) {
            return null;
        }

        var dateValue = null;
        if (_.isNumber(value)) {
            dateValue = new Date(value);
        }
        else if (typeof (value) === "object" && value.getTime) {
            dateValue = value;
        }
        else if (Solovis.isNotNull(value)) {
            throw "Expected number or date.";
        }

        if (this._utcDisplayMode == "local") {
            return dateValue;
        }
        else {
            return Solovis.Time.getUtcDateFromLocalDate(dateValue);
        }
    }


    UtcTimestampParameterControl.prototype.doRenderClassic = function () {
        var self = this;

        this.container.addClass("report-param-utcTimestamp");

        this.container.css("min-width", "300px");

        var utcDisplayMode = this._utcDisplayMode;

        this._inputControl = new Solovis.UI.InputControl({
            container: this.container,
            type: "utcTimestamp",
            value: this.initialParameterValue,
            width: "100%",
            utcDisplayMode: this._utcDisplayMode,
            change: function () {
                self.notifyParameterValueChanged();
            }
        });
    };

    UtcTimestampParameterControl.prototype.setParameterValue = function (newValue) {
        if (this._inputControl) {
            this._inputControl.value(newValue);
        }
        else {
            this.initialParameterValue = newValue;
        }
    };

    UtcTimestampParameterControl.prototype.getParameterValue = function () {
        if (this._inputControl) {
            var value = this._inputControl.value();
            return value;
        }
        else {
            return this.initialParameterValue;
        }
    };

    UtcTimestampParameterControl.prototype.notifyParameterValueChanged = function () {
        $(this).trigger("parameterValueChanged");
    };

})();